import React, { useEffect } from 'react'
import { apiFetch } from 'api/api';
import { getCompanyInfo } from 'api/urls';
import { useHistory } from 'react-router';
import { getQueryParams } from 'utils/Utils';
import * as Actions from "../../state/Actions"
import { capitalize } from 'proptypes/StringProptype';

/* ── design tokens ── */
const T = {
  bg:   '#F6F5F0',
  card: '#FFFFFF',
  line: '#E5E2D8',
  ink:  '#232821',
  mut:  '#6E766C',
  acc:  '#2E9E7A',
};

const CompanyInfo = (props) => {
  const history = useHistory()
  const Params  = getQueryParams(history.location.search)
  const [data, setData] = React.useState()
  const url = getCompanyInfo(Params.company__symbol)
  let dispatch = Actions.getDispatch(React.useContext)

  useEffect(() => {
    const getApiResults = async () => {
      const { data: res, error } = await apiFetch({ url })
      if (error) {
        // Dismiss global loader even on failure so the page doesn't hang
        dispatch(Actions.stateChange('loader', false))
        return;
      }
      if (res) {
        setData(res)
        dispatch(Actions.stateChange('sector', res.sector))
        dispatch(Actions.stateChange('loader', false))
      }
    }
    getApiResults()
    // eslint-disable-next-line
  }, [url])

  if (!data) return null

  /* Initials for avatar */
  const initials = (data.name || '')
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()

  /* Sub-line: sector · industry · est · website */
  const subParts = [
    data.sector,
    data.industry,
    data.founded_year ? `Est. ${data.founded_year}` : null,
    data.website,
  ].filter(Boolean)

  /* Tags: index presence etc. */
  const tags = [data.market_cap_category, data.index_presence].filter(Boolean)

  return (
    <div {...props} style={{
      padding: '14px 0 12px',
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    }}>
      {/* Avatar */}
      <div style={{
        width: 46,
        height: 46,
        borderRadius: 14,
        background: `color-mix(in oklab, ${T.acc} 16%, ${T.card})`,
        backgroundColor: `rgba(46,158,122,0.16)`,
        color: T.acc,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Bricolage Grotesque', sans-serif",
        fontWeight: 800,
        fontSize: 17,
        flexShrink: 0,
      }}>
        {initials}
      </div>

      {/* Name + sub-line */}
      <div style={{ flex: 1 }}>
        <div style={{
          fontFamily: "'Bricolage Grotesque', sans-serif",
          fontSize: 21,
          fontWeight: 800,
          letterSpacing: '-0.02em',
          color: T.ink,
          lineHeight: 1.1,
        }}>
          {data.name ? capitalize(data.name) : ''}
        </div>
        {subParts.length > 0 && (
          <div style={{ fontSize: 12, color: T.mut, marginTop: 2 }}>
            {subParts.join(' · ')}
          </div>
        )}
      </div>

      {/* Tag pills */}
      {tags.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
          {tags.map((tag, i) => (
            <span key={i} style={{
              padding: '5px 12px',
              borderRadius: 999,
              background: T.bg,
              border: `1px solid ${T.line}`,
              fontSize: 11,
              fontWeight: 600,
              color: T.mut,
            }}>
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default CompanyInfo
